<script>
export default {
    props: {
        data: Object,
        animate: Boolean,
        anchor: Boolean
    },
};
</script>

<template>
    <div @click="$router.push(`/produktkategorien/${data.slug.name}`)"
        class="rounded-md shadow-md border-2 border-gray-200 hover:shadow-lg p-4 flex flex-row items-center gap-4 cursor-pointer transition-all ease-in-out group">
        <div class="w-12 h-12 rounded-md text-white flex-shrink-0">
            <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-gradient.png')"
                class="w-full h-full object-contain" />
        </div>
        <div class="group-hover:ml-2 transition-all ease-in-out">
            <h4 class="base_bold">
                {{ $translate(data.name) }}
            </h4>
            <small>
                {{ $t('plain_learn_more') }}
            </small>
        </div>
    </div>
</template>
